import { get_feed_info } from "./helpers";

var template = require("./../templates/recommended-user-card.handlebars");

$(function () {
  const feed_info = get_feed_info();

  $.ajax({
    method: "GET",
    url: "/api/users/suggestions",
    data: { limit: 30, topic: feed_info.topic },
    success: function (data) {
      // Hide loading state
      $("#loading_state").hide();

      if (data.length === 0) {
        // Show empty state
        $("#empty_state").removeClass("hidden");
      } else {
        let visibleCount = 0;
        const pageSize = 10;

        function renderNextPage() {
          data.slice(visibleCount, visibleCount + pageSize).forEach(function (user) {
            $("#user_list").append(template(user));
          });
          visibleCount += pageSize;
          $("#show_more_recommendations").toggleClass(
            "hidden",
            visibleCount >= data.length
          );
        }

        renderNextPage();
        $("#show_more_recommendations").on("click", renderNextPage);
      }
    },
    error: function () {
      // Hide loading state and show error
      $("#loading_state").hide();
      $("#empty_state").removeClass("hidden");
      $("#empty_state p").text("Sorry, we couldn't load recommendations. Please try again later.");
    }
  });
});
